export default __webpack_public_path__ + "static/media/Pippa_9781846164583.19503d7e.jpg";